// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"202b8111","937":"e53aa199"}[chunkId] + ".chunk.js";
};